<template>
  <div>
    <provisioning-status @refresh="load" />
    <v-card class="main-card">
      <v-card-title class="screen-title">
        <span>サイトゾーン一覧(Type1)</span>
        <manual-button path="/type1-internet-site-list/" />
      </v-card-title>

      <v-card-text class="pa-2 mt-3" v-if="isLoaded">
        <v-tabs v-model="tabValue" grow hide-slider>
          <v-tab text="インターネットサイト" value="internet"></v-tab>
          <v-tab text="エクストラサイト" value="extra"></v-tab>
          <v-tab text="プライベートサイト" value="private"></v-tab>
        </v-tabs>
        <v-tabs-window v-model="tabValue" style="min-height: 60vh">
          <!-- インターネットサイトタブ-->
          <v-tabs-window-item value="internet">
            <!-- グローバルゾーン-->
            <v-card>
              <v-card-text class="pa-0">
                <v-container>
                  <div class="ml-2">
                    <v-row no-gutters>
                      <v-col cols="3">
                        <app-label-group
                          label="グローバルゾーン"
                          :value="globalZone ? '作成済' : '未作成'"
                        />
                      </v-col>
                      <v-col cols="5">
                        <app-label-group
                          label="グローバルゾーン名"
                          :value="globalZone ? globalZone.zoneName : '-'"
                        />
                      </v-col>
                      <v-col class="text-right">
                        <v-btn
                          @click="showGlobalZoneEdit"
                          color="primary"
                          v-permission.config
                          >ゾーン編集</v-btn
                        >
                      </v-col>
                    </v-row>
                  </div>
                </v-container>
              </v-card-text>
            </v-card>

            <v-card class="mt-3">
              <v-card-text class="pa-0">
                <v-container>
                  <!-- アドレス-->
                  <v-row>
                    <v-col>
                      <h3>サイト情報</h3>
                    </v-col>
                    <div class="d-flex flex-row ga-1 flex-wrap mr-1">
                      <v-btn
                        color="primary"
                        @click="showInternetSiteEdit"
                        v-permission.config
                        >サイト編集</v-btn
                      >
                    </div>
                  </v-row>

                  <!-- アドレステーブル-->
                  <v-row no-gutters>
                    <span class="font-weight-bold my-2"> アドレス </span>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>
                      <app-search
                        :search="addressList.search"
                        v-model="addressList.filter"
                      />
                    </v-col>
                  </v-row>
                  <div class="d-flex flex-row justify-end mb-2">
                    <v-btn color="primary" @click="reloadInternet"
                      >一覧更新</v-btn
                    >
                  </div>
                  <app-table
                    v-model:table-sort-by="addressList.sortBy"
                    :sort-null-last="true"
                    :sort-compare="customSortAddress"
                    :sort-compare-key="['ipAddressName']"
                    :fields="addressList.fields"
                    :items="addressList.items"
                    :filter="addressList.filter"
                    :filter-option="addressList.filter_option"
                    primary-key="ipAddressId"
                    sticky-header="50vh"
                    :tr-class="() => undefined"
                  >
                    <!-- アドレス名 -->
                    <template #cell(ipAddressName)="{ value }">
                      {{ $filter.emptyTo(value, "-") }}
                    </template>
                    <!-- ゾーン配置 -->
                    <template #cell(zoneId)="{ value }">
                      {{ value ? "配置済" : "未配置" }}
                    </template>
                  </app-table>

                  <!-- FQDN-->
                  <v-row no-gutters>
                    <span class="font-weight-bold mb-2 mt-4"> FQDN </span>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>
                      <app-search
                        :search="fqdnList.search"
                        v-model="fqdnList.filter"
                      />
                    </v-col>
                  </v-row>
                  <div class="d-flex flex-row justify-end mb-2">
                    <v-btn color="primary" @click="reloadInternet"
                      >一覧更新</v-btn
                    >
                  </div>
                  <app-table
                    v-model:table-sort-by="fqdnList.sortBy"
                    :sort-null-last="true"
                    :sort-compare="customSortFqdn"
                    :sort-compare-key="['fqdnName']"
                    :fields="fqdnList.fields"
                    :items="fqdnList.items"
                    :filter="fqdnList.filter"
                    :filter-option="fqdnList.filter_option"
                    primary-key="fqdnId"
                    sticky-header="50vh"
                    :tr-class="() => undefined"
                  >
                    <!-- FQDN名 -->
                    <template #cell(fqdnName)="{ value }">
                      {{ $filter.emptyTo(value, "-") }}
                    </template>
                    <!-- ゾーン配置 -->
                    <template #cell(zoneId)="{ value }">
                      {{ value ? "配置済" : "未配置" }}
                    </template>
                  </app-table>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tabs-window-item>

          <!-- エクストラサイトタブ-->
          <v-tabs-window-item value="extra">
            <!-- エクストラゾーン-->
            <v-card>
              <v-card-text class="pa-0">
                <v-container>
                  <div class="ml-2">
                    <v-row no-gutters>
                      <v-col cols="3">
                        <app-label-group
                          label="エクストラゾーン"
                          :value="extraZone ? '作成済' : '未作成'"
                        />
                      </v-col>
                      <v-col cols="5">
                        <app-label-group
                          label="エクストラゾーン名"
                          :value="extraZone ? extraZone.zoneName : '-'"
                        />
                      </v-col>
                      <v-col class="text-right">
                        <v-btn
                          @click="showExtraZoneEdit"
                          color="primary"
                          v-permission.config
                          >ゾーン編集</v-btn
                        >
                      </v-col>
                    </v-row>
                  </div>
                </v-container>
              </v-card-text>
            </v-card>

            <v-card class="mt-3">
              <v-card-text class="pa-0">
                <v-container>
                  <!-- エクストラ-->
                  <v-row>
                    <v-col>
                      <h3>サイト情報</h3>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="mt-2">
                    <v-col>
                      <app-search
                        :search="extra.search"
                        v-model="extra.filter"
                      />
                    </v-col>
                    <div class="d-flex flex-row ga-1 flex-wrap ml-2">
                      <v-btn
                        color="primary"
                        @click="showExtraSiteEdit"
                        v-permission.config
                        >サイト編集</v-btn
                      >
                    </div>
                  </v-row>
                  <!-- エクストラサイトテーブル-->
                  <div class="d-flex flex-row justify-end mb-2">
                    <v-btn color="primary" @click="reloadExtra">一覧更新</v-btn>
                  </div>
                  <app-table
                    v-model:table-sort-by="extra.sortBy"
                    :sort-null-last="true"
                    :sort-compare="customSortExtra"
                    :sort-compare-key="['siteName']"
                    :fields="extra.fields"
                    :items="extra.items"
                    :filter="extra.filter"
                    :filter-option="extra.filter_option"
                    primary-key="ipAddressId"
                    sticky-header="50vh"
                    :tr-class="() => undefined"
                  >
                    <template #cell(ipAddressName)="{ value }">
                      {{ $filter.emptyTo(value, "-") }}
                    </template>
                    <template #cell(ipAddress)="{ value }">
                      {{ $filter.emptyTo(value, "-") }}
                    </template>
                    <template #cell(zoneId)="data">
                      {{ $filter.emptyTo(data.value, "-") }}
                    </template>
                  </app-table>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tabs-window-item>

          <!-- プライベートサイトタブ-->
          <v-tabs-window-item value="private">
            <!-- プライベートゾーン-->
            <v-card>
              <v-card-text class="pa-0">
                <v-container>
                  <div class="ml-2">
                    <v-row no-gutters>
                      <v-col cols="3">
                        <app-label-group
                          label="プライベートゾーン"
                          :value="
                            privateZoneList.length === 0 ? '未作成' : '作成済'
                          "
                        />
                      </v-col>
                      <v-col cols="5">
                        <app-label-group label="プライベートゾーン名">
                          <template #value>
                            <div
                              v-if="privateZoneList.length !== 0"
                              class="ml-3"
                            >
                              <span
                                v-for="(item, index) in privateZoneList"
                                :key="index"
                              >
                                {{ item.zoneName
                                }}<span
                                  v-if="index !== privateZoneList.length - 1"
                                  >,</span
                                ></span
                              >
                            </div>
                            <div v-else>
                              <span>{{ "-" }}</span>
                            </div>
                          </template>
                        </app-label-group>
                      </v-col>
                      <v-col class="text-right">
                        <v-btn
                          @click="showPrivateZoneEdit"
                          color="primary"
                          v-permission.config
                          >ゾーン編集</v-btn
                        >
                      </v-col>
                    </v-row>
                  </div>
                </v-container>
              </v-card-text>
            </v-card>

            <v-card class="mt-3">
              <v-card-text class="pa-0">
                <v-container>
                  <!-- プライベート-->
                  <v-row>
                    <v-col>
                      <h3>サイト情報</h3>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="mt-2">
                    <v-col>
                      <app-search
                        :search="private.search"
                        v-model="private.filter"
                      />
                    </v-col>
                  </v-row>
                  <!-- プライベートサイトテーブル-->
                  <div class="d-flex flex-row justify-end mb-2">
                    <v-btn color="primary" @click="reloadPrivate"
                      >一覧更新</v-btn
                    >
                  </div>
                  <app-table
                    v-model:table-sort-by="private.sortBy"
                    :sort-null-last="true"
                    :sort-compare="customSortPrivate"
                    :sort-compare-key="['enumber']"
                    :fields="private.fields"
                    :items="private.items"
                    :hover="true"
                    :filter="private.filter"
                    :filter-option="private.filter_option"
                    primary-key="siteId"
                    sticky-header="50vh"
                    @click:row="privateSelected"
                    :td-class="cellClass"
                  >
                    <template #cell(ipAddressName)="data">
                      <template v-if="data.item.ipAddressName">
                        <div
                          v-for="(item, index) in data.item.ipAddressName"
                          :key="index"
                        >
                          {{ $filter.emptyTo(item, "-") }}
                        </div>
                      </template>
                      <template v-else>{{ "-" }}</template>
                    </template>
                    <template #cell(ipAddress)="data">
                      <template v-if="data.item.ipAddress">
                        <div
                          v-for="(item, index) in data.item.ipAddress"
                          :key="index"
                        >
                          {{ item }}
                        </div>
                      </template>
                      <template v-else>{{ "-" }}</template>
                    </template>
                    <template #cell(zoneId)="data">
                      <template v-if="data.item.zoneId">
                        <div
                          v-for="(item, index) in data.item.zoneId"
                          :key="index"
                        >
                          {{ item }}
                        </div>
                      </template>
                      <template v-else>{{ "-" }}</template>
                    </template>
                  </app-table>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tabs-window-item>
        </v-tabs-window>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import type {
  Type1ExtraInfo,
  Type1ExtraList,
  Type1InternetAddress,
  Type1InternetFQDN,
  Type1InternetInfo,
  Type1PrivateInfo,
  Type1PrivateLine,
  Type1PrivateList,
  Type1Zone,
} from "@/apis/Type1SiteApi";
import type { VNConnect } from "@/apis/VNConnectApi";
import { defineComponent } from "vue";
import ZoneEdit from "@/modals/type1/ZoneEdit.vue";
import PrivateSiteReference from "@/modals/type1/PrivateSiteReference.vue";
import InternetSiteReference from "@/modals/type1/InternetSiteReference.vue";
import ExtraSiteList from "@/modals/type1/ExtraSiteList.vue";
import PrivateZoneList from "@/modals/type1/PrivateZoneList.vue";
import type { SortCompareFunc } from "@/services/SortService";
import type {
  AppTableHeader,
  FilterOption,
  SortItem,
} from "@/components/AppTable.vue";
import type { SearchOption } from "@/components/AppSearch.vue";

export default defineComponent({
  name: "Type1SiteZoneList",
  data() {
    return {
      tabValue: "internet",
      isLoaded: false,
      internetSiteZone: {} as Type1InternetInfo,
      extraSiteZone: {} as Type1ExtraInfo,
      privateSiteZone: {} as Type1PrivateInfo,
      /** グローバルゾーン */
      globalZone: {} as Type1Zone | null,
      /** エクストラゾーン */
      extraZone: {} as Type1Zone | null,
      /** プライベートゾーン */
      privateZoneList: [] as Type1Zone[],
      /** インターネットアドレス */
      addressList: {
        sortBy: {
          key: "ipAddressName",
          order: "asc",
        } as SortItem,
        fields: FIELDS.address,
        items: [] as Type1InternetAddress[],
        selected: [],
        search: {
          ipAddressName: {
            type: "text",
            label: "アドレス名",
          },
          ipAddress: {
            type: "text",
            label: "アドレス",
          },
        } as SearchOption,
        filter: {} as Record<string, unknown>,
        filter_option: {
          ipAddressName: "like",
          ipAddress: "like",
        } as FilterOption,
      },
      /** インターネットFQDN */
      fqdnList: {
        sortBy: {
          key: "fqdnName",
          order: "asc",
        } as SortItem,
        fields: FIELDS.fqdn,
        items: [] as Type1InternetFQDN[],
        selected: [],
        search: {
          fqdnName: {
            type: "text",
            label: "FQDN名",
          },
          fqdn: {
            type: "text",
            label: "FQDN",
          },
        } as SearchOption,
        filter: {} as Record<string, unknown>,
        filter_option: {
          fqdnName: "like",
          fqdn: "like",
        } as FilterOption,
      },
      /** エクストラサイト */
      extra: {
        sortBy: {
          key: "siteName",
          order: "asc",
        } as SortItem,
        fields: FIELDS.extra,
        items: [] as Type1ExtraList[],
        selected: [],
        search: {
          siteName: {
            type: "text",
            label: "サイト名",
          },
          ipAddressName: {
            type: "text",
            label: "アドレス名",
          },
          ipAddress: {
            type: "text",
            label: "アドレス",
          },
        } as SearchOption,
        filter: {} as Record<string, unknown>,
        filter_option: {
          siteName: "like",
          ipAddressName: "like",
          ipAddress: "like",
        } as FilterOption,
      },
      /** プライベートサイト */
      private: {
        sortBy: {
          key: "enumber",
          order: "asc",
        } as SortItem,
        fields: FIELDS.private,
        items: [] as Type1PrivateList[],
        selected: [],
        search: {
          enumber: {
            type: "text",
            label: "回線番号",
          },
          siteName: {
            type: "text",
            label: "サイト名",
          },
          ipAddressName: {
            type: "text",
            label: "アドレス名",
          },
          ipAddress: {
            type: "text",
            label: "アドレス",
          },
        } as SearchOption,
        filter: {} as Record<string, unknown>,
        filter_option: {
          enumber: "like",
          siteName: "like",
          ipAddressName: "like",
          ipAddress: "like",
        } as FilterOption,
      },
    };
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  computed: {
    /** インターネットアドレスカスタムソート */
    customSortAddress(): SortCompareFunc<Type1InternetAddress> {
      return this.$service.tableSortCompare(
        this.addressList.sortBy,
        ["ipAddressName", { nullLast: true }],
        ["ipAddress", "asc"]
      );
    },
    /** インターネットFqdnカスタムソート */
    customSortFqdn(): SortCompareFunc<Type1InternetFQDN> {
      return this.$service.tableSortCompare(
        this.fqdnList.sortBy,
        ["fqdnName", { nullLast: true }],
        ["fqdn", "asc"]
      );
    },
    /** エクストラカスタムソート */
    customSortExtra(): SortCompareFunc<Type1ExtraList> {
      return this.$service.tableSortCompare(
        this.extra.sortBy,
        "siteName",
        ["ipAddressName", "asc", { nullLast: true }],
        ["ipAddress", "asc"]
      );
    },
    /** プライベートカスタムソート */
    customSortPrivate(): SortCompareFunc<Type1PrivateList> {
      return this.$service.tableSortCompare(this.private.sortBy, "enumber", [
        "siteName",
        "asc",
      ]);
    },
  },
  methods: {
    /** 初期化機能 */
    async load() {
      // インターネットサイトゾーン情報を取得用APIを呼び出し、データ取得を行う
      await this.getInternetList();
      // エクストラサイトゾーン情報を取得用APIを呼び出し、データ取得を行う
      await this.getExtraList();
      // プライベートサイトゾーン情報を取得用APIを呼び出し、データ取得を行う
      await this.getPrivateList();
    },
    /** インターネットサイトタブ一覧更新 */
    async reloadInternet() {
      await this.getInternetList();
    },
    /** エクストラサイトタブ一覧更新 */
    async reloadExtra() {
      await this.getExtraList();
    },
    /** プライベートサイトタブ一覧更新 */
    async reloadPrivate() {
      await this.getPrivateList();
    },
    /** インターネット一覧のデータ取得を行う*/
    async getInternetList() {
      this.internetSiteZone =
        await this.$api.type1SiteZone.getType1InternetList();
      this.globalZone = this.internetSiteZone.zone;
      // 取得した配列のソート
      this.addressList.items = this.internetSiteZone.addressList.sort(
        (a, b) => {
          return this.$service.sortCompare(a, b, [
            ["ipAddressName", "asc", { nullLast: true }],
            ["ipAddress", "asc"],
          ]);
        }
      );
      // 取得した配列のソート
      this.fqdnList.items = this.internetSiteZone.fqdnList.sort((a, b) => {
        return this.$service.sortCompare(a, b, [
          ["fqdnName", "asc", { nullLast: true }],
          ["fqdn", "asc"],
        ]);
      });
    },
    /** エクストラ一覧のデータ取得を行う*/
    async getExtraList() {
      // リストをクリアする処理
      this.extra.items = [];
      this.extraSiteZone = await this.$api.type1SiteZone.getType1ExtraList();
      this.extraZone = this.extraSiteZone.zone;
      /**
       * 取得IPアドレス配列のソート
       */
      this.extraSiteZone.siteList.forEach((e) => {
        e.addressList.sort((a, b) => {
          return this.$service.sortCompare(a, b, [
            ["ipAddressName", "asc", { nullLast: true }],
            ["ipAddress", "asc"],
          ]);
        });
      });
      /**
       * 一覧表示用に変換
       * ※当画面のみの特殊対応です。
       * Aサイト
       *  L Aアドレス
       *  L Bアドレス
       * 上記の形式のオブジェクトを以下のように表示する必要があるため、
       * コード通りの詰め替え処理をしています。
       * Aサイト - Aアドレス
       * Aサイト - Bアドレス
       */
      this.extraSiteZone.siteList.map((e) => {
        e.addressList.map((i) => {
          this.extra.items.push({
            siteName: e.siteName,
            ipAddressId: i.ipAddressId,
            ipAddressName: i.ipAddressName,
            ipAddress: i.ipAddress,
            zoneId: i.zoneId,
          });
        });
        /**
         * 0件の場合サイト名以外”-”を表示
         * ipAddressIdをキーにしたいので、
         * siteIdを入れます。
         */
        if (e.addressList.length < 1) {
          this.extra.items.push({
            siteName: e.siteName,
            ipAddressId: e.siteId,
            ipAddressName: null,
            ipAddress: null,
            zoneId: null,
          });
        }
      });
    },
    /** プライベート一覧のデータ取得を行う*/
    async getPrivateList() {
      this.private.items = [];
      this.privateSiteZone =
        await this.$api.type1SiteZone.getType1PrivateList();
      this.privateZoneList = this.privateSiteZone.zoneList.sortBy([
        (e) => e.zoneName,
        "asc",
      ]);

      // VNコネクトを利用しているか判定するためデータ取得
      const vnInformationList = (
        await this.$api.vNConnect.getVNConnects()
      ).vnConnectList.map(({ enumber, vlanId }: VNConnect) => ({
        enumber,
        vlanId,
      }));

      /**
       * 一覧表示用に変換
       * ※当画面のみの特殊対応です。
       * A回線
       *  L Aサイト
       *  L Bサイト
       * 上記の形式のオブジェクトを以下のように表示する必要があるため、
       * コード通りの詰め替え処理をしています。
       * A回線 - Aサイト
       *          L Aアドレス
       *          L Bアドレス
       * A回線 - Bサイト
       *          L Aアドレス
       *          L Bアドレス
       */
      this.privateSiteZone.lineList.forEach((e) => {
        e.siteList
          .filter((i) => {
            switch (e.accessType) {
              case "ETHERNET_L3":
              case "BROADBAND_ACCESS2_L3":
              case "WIRELESS_ACCESS_L3":
              case "PF_ACCESS_GW":
                return i.vlanIdType !== "SPECIFIED";
              default:
                return true;
            }
          })
          .forEach((i) => {
            // 取得IPアドレス配列のソート
            i.addressList.sort((a, b) => {
              return this.$service.sortCompare(a, b, [
                ["ipAddressName", "asc", { nullLast: true }],
                ["ipAddress", "asc"],
              ]);
            });
            // 詰め替え処理
            const addressName = i.addressList.map((x) => {
              return x.ipAddressName;
            });

            const address = i.addressList.map((x) => {
              return x.ipAddress;
            });
            const zoneName = i.addressList.map((x) => {
              const era: Type1Zone | undefined = this.privateZoneList.find(
                (item) => item.zoneId === x.zoneId
              );
              return era ? era.zoneName : "未配置";
            });

            let listDisplay = true;
            // 物理回線で利用不可の回線は表示しない処理
            switch (e.accessType) {
              case "ETHERNET2":
              case "PLATFORM_GATEWAY":
              case "ETHERNET2_PF":
              case "BROADBAND_ACCESS3":
              case "ETHERNET_LIGHT":
              case "WIRELESS_ACCESS2":
              case "PF_ACCESS_GW2":
                listDisplay = false;
                break;
              case "ETHERNET_L2":
              case "BROADBAND_ACCESS2_L2":
              case "WIRELESS_ACCESS_L2":
                // イーサネット方式L2・ブロードバンドアクセス方式L2・ワイヤレスアクセス方式L2で回線種別がVLAN指定かつVNコネクト利用ありの場合表示しない
                if (
                  vnInformationList.find(
                    (element) =>
                      i.vlanIdType === "SPECIFIED" &&
                      e.enumber === element.enumber &&
                      i.vlanId === element.vlanId
                  )
                ) {
                  listDisplay = false;
                  break;
                }
                // イーサネット方式L2・ブロードバンドアクセス方式L2・ワイヤレスアクセス方式L2で回線種別がUntagかつVNコネクト利用ありの場合表示しない
                else if (
                  vnInformationList.find(
                    (element) =>
                      i.vlanIdType === "UNTAG" &&
                      e.enumber === element.enumber &&
                      i.vlanId === element.vlanId
                  )
                ) {
                  listDisplay = false;
                  break;
                } else {
                  break;
                }
              case "REMOTE_ACCESS_GW_FRE":
              case "REMOTE_ACCESS_GW_CPA":
              case "REMOTE_ACCESS_GW_CRG":
              case "EXTEND_ETHERNET":
                // リモートアクセスGW・エクステンドイーサネット方式で回線種別がVLAN指定の場合表示しない
                if (i.vlanIdType === "SPECIFIED") {
                  listDisplay = false;
                  break;
                }
                // リモートアクセスGW・エクステンドイーサネット方式で回線種別がUntagかつVNコネクト利用ありの場合表示しない
                else if (
                  vnInformationList.find(
                    (element) =>
                      i.vlanIdType === "UNTAG" && e.enumber === element.enumber
                  )
                ) {
                  listDisplay = false;
                  break;
                } else {
                  break;
                }
              case "REMOTE_ACCESS_GW2_FRE":
              case "REMOTE_ACCESS_GW2_CPA":
              case "REMOTE_ACCESS_GW2_CRG":
              case "IPSEC":
                // リモートアクセスGW2・IPSec方式で回線種別がUntagかつVNコネクト利用ありの場合表示しない
                if (
                  vnInformationList.find(
                    (element) =>
                      i.vlanIdType === "UNTAG" && e.enumber === element.enumber
                  )
                ) {
                  listDisplay = false;
                  break;
                } else {
                  break;
                }
            }
            // OTHERの場合表示しない処理。
            if (i.vlanIdType !== "OTHER" && listDisplay === true) {
              // アドレス０件の場合ハイフンを表示。
              if (i.addressList.length < 1) {
                this.private.items.push({
                  siteId: i.siteId,
                  enumber: e.enumber,
                  siteName: i.siteName,
                  vlan: i.vlanIdType === "UNTAG" ? "Untag" : i.vlanId,
                  ipAddressName: null,
                  ipAddress: null,
                  zoneId: null,
                });
              } else {
                this.private.items.push({
                  siteId: i.siteId,
                  enumber: e.enumber,
                  siteName: i.siteName,
                  vlan: i.vlanIdType === "UNTAG" ? "Untag" : i.vlanId,
                  ipAddressName: addressName,
                  ipAddress: address,
                  zoneId: zoneName,
                });
              }
            }
          });
      });
    },
    /** 行選択イベント*/
    // プライベートサイト
    async privateSelected(item: Type1PrivateList) {
      // 選択されたのサイトを洗い出す
      const data: Type1PrivateLine | undefined =
        this.privateSiteZone.lineList.find((e) => e.enumber === item.enumber);
      const siteList = data?.siteList.find((e) => e.siteId === item.siteId);

      await this.$modal.show(PrivateSiteReference, {
        enumber: item.enumber,
        siteList: siteList,
        zoneList: this.privateZoneList,
        type1SiteZoneKeyId: this.privateSiteZone.type1SiteZoneKeyId,
      });
      this.isLoaded = false;
      await this.load();
      this.isLoaded = true;
    },

    /** 編集機能 */
    // グローバルゾーン編集
    async showGlobalZoneEdit() {
      await this.$modal.show(ZoneEdit, {
        zoneMode: "global",
        zoneDate: this.internetSiteZone.zone,
        type1SiteZoneKeyId: this.internetSiteZone.type1SiteZoneKeyId,
      });
      this.isLoaded = false;
      await this.load();
      this.isLoaded = true;
    },
    // インターネットサイト編集
    async showInternetSiteEdit() {
      await this.$modal.show(InternetSiteReference, {
        internetSiteZone: this.internetSiteZone,
      });
      this.isLoaded = false;
      await this.load();
      this.isLoaded = true;
    },
    // エクストラゾーン編集
    async showExtraZoneEdit() {
      await this.$modal.show(ZoneEdit, {
        zoneMode: "extra",
        zoneDate: this.extraSiteZone.zone,
        type1SiteZoneKeyId: this.extraSiteZone.type1SiteZoneKeyId,
      });
      this.isLoaded = false;
      await this.load();
      this.isLoaded = true;
    },
    // エクストラサイト編集
    async showExtraSiteEdit() {
      await this.$modal.show(ExtraSiteList, {
        extraSiteZone: this.extraSiteZone,
      });
      this.isLoaded = false;
      await this.load();
      this.isLoaded = true;
    },
    // プライベートゾーン編集
    async showPrivateZoneEdit() {
      await this.$modal.show(PrivateZoneList, {
        privateZone: this.privateZoneList,
        type1SiteZoneKeyId: this.privateSiteZone.type1SiteZoneKeyId,
      });
      this.isLoaded = false;
      await this.load();
      this.isLoaded = true;
    },
    /** tdにクラスをつける */
    cellClass(field: AppTableHeader<Type1PrivateList>): string[] | undefined {
      if (field.key === "vlan") {
        return ["text-right"];
      }
      return undefined;
    },
  },
});

/** テーブルfields*/
const FIELDS = {
  address: [
    {
      key: "ipAddressName",
      title: "アドレス名",
      sortable: true,
    },
    {
      key: "ipAddress",
      title: "アドレス",
      sortable: true,
      width: "200px",
    },
    {
      key: "zoneId",
      title: "ゾーン配置",
      sortable: true,
      width: "180px",
    },
  ] as AppTableHeader<Type1InternetAddress>[],
  fqdn: [
    {
      key: "fqdnName",
      title: "FQDN名",
      sortable: true,
    },
    {
      key: "fqdn",
      title: "FQDN",
      sortable: true,
      width: "200px",
    },
    {
      key: "zoneId",
      title: "ゾーン配置",
      sortable: true,
      width: "180px",
    },
  ] as AppTableHeader<Type1InternetFQDN>[],
  extra: [
    {
      key: "siteName",
      title: "サイト名",
      sortable: true,
      width: "200px",
    },
    {
      key: "ipAddressName",
      title: "アドレス名",
      sortable: true,
    },
    {
      key: "ipAddress",
      title: "アドレス",
      sortable: true,
      width: "200px",
    },
    {
      key: "zoneId",
      title: "ゾーン配置",
      sortable: true,
      width: "180px",
      sortByFormatted: true,
      filterByFormatted: false,
      formatter: (value: null, key: null, item: Type1ExtraList) => {
        if (item.ipAddress === null && item.zoneId === null) {
          return null;
        } else if (item.zoneId === null) {
          return "未配置";
        } else {
          return "配置済";
        }
      },
    },
  ] as AppTableHeader<Type1ExtraList>[],
  private: [
    {
      key: "enumber",
      title: "回線番号",
      sortable: true,
      width: "180px",
    },
    {
      key: "siteName",
      title: "サイト名",
      sortable: true,
      width: "200px",
    },
    {
      key: "vlan",
      title: "VLAN",
      sortable: true,
      width: "150px",
    },
    {
      key: "ipAddressName",
      title: "アドレス名",
      sortable: true,
    },
    {
      key: "ipAddress",
      title: "アドレス",
      sortable: true,
      width: "200px",
    },
    {
      key: "zoneId",
      title: "ゾーン配置",
      sortable: true,
      width: "180px",
    },
  ] as AppTableHeader<Type1PrivateList>[],
};
</script>
